import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";

const setUniversalKeyboardState = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SET_UNIVERSAL_KEYBOARD_STATE),
        switchMap(({payload}) => {
            if (!state$.value.settings.virtualKeyboardEnabled) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_UNIVERSAL_KEYBOARD_STATE,
                    payload: {
                        state: payload.state,
                        selector: payload.selector
                    }
                }
            ];
        })
    );

export default [setUniversalKeyboardState];
